import { render, staticRenderFns } from "./UseDialog.vue?vue&type=template&id=772c6e76&scoped=true&"
import script from "./UseDialog.vue?vue&type=script&lang=js&"
export * from "./UseDialog.vue?vue&type=script&lang=js&"
import style0 from "./UseDialog.vue?vue&type=style&index=0&id=772c6e76&lang=less&scoped=true&"
import style1 from "./UseDialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772c6e76",
  null
  
)

export default component.exports